import { useEffect } from 'react'
import { useProductAnalyticsContext } from 'features/product-analytics/ProductAnalyticsProvider'
import { Logger } from 'features/logging/Logging.services'

export default function useCommitVersionLogger() {
  const { trackEvent } = useProductAnalyticsContext()

  useEffect(() => {
    Logger.log(`App Version: ${COMMIT_HASH || 'N/A'}`)
    trackEvent({ type: 'AppVersionReported', payload: { version: COMMIT_HASH } })
  }, [])
}
